import { render, staticRenderFns } from "./InputCreate.vue?vue&type=template&id=24e9103c"
import script from "./InputCreate.vue?vue&type=script&lang=js"
export * from "./InputCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports